var React = require('react');

function TieInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"24","width":"22","height":"7","fill":"#4CA2FF","key":0}),React.createElement("rect",{"x":"6","y":"37","width":"22","height":"7","transform":"rotate(-90 6 37)","fill":"#6EDDF0","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.5 7C16.8056 7 13 10.8056 13 15.5H6C6 6.93959 12.9396 0 21.5 0C30.0604 0 37 6.93959 37 15.5C37 24.0604 30.0604 31 21.5 31V24C26.1944 24 30 20.1944 30 15.5C30 10.8056 26.1944 7 21.5 7Z","fill":"#4CA2FF","key":2})]);
}

TieInline.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = TieInline;

TieInline.default = TieInline;
